<div class="content">

  <div  class="title">
    @if (!(showRemotePlayer$ | async) || (remotePlayerActive$ | async)) {
      Tunify Connect
    }
    @if ((showRemotePlayer$ | async) && !(remotePlayerActive$ | async)) {
      {{'connect.closed' | translate}}
    }

  </div>


  <div class="remoteButtonContainer">
    <button
      class="connectButton {{(showRemotePlayer$ | async) ? 'remoteButton' : 'playerButton'}}"
      disabled="true"
      >
      <tun-remote-icon class="remote-icon"></tun-remote-icon>
    </button>
  </div>



  <!-- we are remote: show player -->
  @if ((showRemotePlayer$ | async) && (remotePlayerActive$ | async)) {
    <div class="info">
      {{'connect.info1' | translate}}
    </div>
    <div fxLayout="column" class="devices">
      @if ((remotePlayerApplicationInfo$ | async) != null) {
        <div>
          {{(remotePlayerApplicationInfo$ | async).deviceInfo}}
        </div>
      }
    </div>
    <div class="info infoLast">
      {{'connect.info2' | translate}}
    </div>
  }

  <!-- we are remote: no player active -->
  @if ((showRemotePlayer$ | async) && !(remotePlayerActive$ | async)) {
    <div class="info">
      {{'connect.noPlayer.info1' | translate}}
    </div>
    @if ((lastPlayerApplicationInfo$ | async) != null) {
      <div fxLayout="column" class="devices">
        {{(lastPlayerApplicationInfo$ | async).deviceInfo}}
      </div>
    }
    <div class="info infoLast">
      {{'connect.noPlayer.info2' | translate}}
    </div>
  }

  <!-- we are a player: show remotes -->
  @if (!(showRemotePlayer$ | async)) {
    <div class="info">
      {{'connect.remote.info1' | translate}}
    </div>
    <div fxLayout="column" class="devices">
      @for (remoteApplicationInfo of (remoteRemoteApplicationInfos$ | async); track remoteApplicationInfo) {
        <div>
          {{remoteApplicationInfo.deviceInfo}}
        </div>
      }
    </div>
    <div class="info infoLast">
      {{'connect.remote.info2' | translate}}
    </div>
  }

  <div class="buttons-container">
    @if ((showRemotePlayer$ | async)) {
      <div class="buttons-left-side">
        <button class="confirm-button" (click)="stopConnect()">{{'connect.stop' | translate}}</button>
      </div>
    }
    <div class="buttons-right-side">
      <button class="confirm-button" (click)="close()" cdkFocusInitial>OK</button>
    </div>
  </div>






</div>
